import React, { FC } from 'react';
import { ResponsibleAutocompleteProps } from './ResponsibleAutocompleteProps';
import { FormControl, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { returnDisabledStatus } from '../../../../../utils/fieldEditingRules';
import InputField from '@ingka/input-field';
import CDSComboBox from '../../../../CDSComboBox';

export const emailRegex = /^[A-Za-z0-9._%+-]+@(ingka\.com|ingka\.ikea\.com)$/i;

const ResponsibleAutocomplete: FC<ResponsibleAutocompleteProps> = ({
  id,
  options,
  label,
  name,
  testid,
  required,
}) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  const disabledFields = watch('disabledFields');

  return (
    <Controller
      render={({ field: { onChange, value } }) =>
        returnDisabledStatus(disabledFields, name) ? (
          <InputField
            className={'read-only-input'}
            id={id}
            type={'text'}
            label={`${label}${required ? ' *' : ''}`}
            value={value}
            data-testid={testid}
            readOnly
          />
        ) : (
          <FormControl
            fullWidth
            required={required}
            error={!!errors?.[name]?.message}
          >
            <CDSComboBox
              value={value}
              onChange={onChange}
              id={id}
              options={options}
              label={label}
              error={!!errors?.[name]?.message}
              testId={testid}
              required={required}
            />

            {!!errors?.[name]?.message && (
              <FormHelperText>{errors?.[name]?.message}</FormHelperText>
            )}
          </FormControl>
        )
      }
      name={name}
      control={control}
    />
  );
};

export default ResponsibleAutocomplete;
